// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var Filters$ReactHooksTemplate = require("../dashboard/filters/filters.res.js");

function email(t) {
  return t.email;
}

function lob(t) {
  return t.lob;
}

function touchPoint(t) {
  return t.touchPoint;
}

function open_(t) {
  return t.open_;
}

function closed(t) {
  return t.closed;
}

function parked(t) {
  return t.parked;
}

function resolved(t) {
  return t.resolved;
}

function fromJson(json) {
  return {
          email: Json_decode.field("agent", Json_decode.string, json),
          touchPoint: Json_decode.optional((function (param) {
                  return Json_decode.field("touch_point", Json_decode.string, param);
                }), json),
          lob: Json_decode.optional((function (param) {
                  return Json_decode.field("lob", Json_decode.string, param);
                }), json),
          open_: Json_decode.field("open", Json_decode.$$int, json),
          closed: Json_decode.field("closed", Json_decode.$$int, json),
          parked: Json_decode.field("parked", Json_decode.$$int, json),
          resolved: Json_decode.field("resolved", Json_decode.$$int, json)
        };
}

var AgentData = {
  email: email,
  lob: lob,
  touchPoint: touchPoint,
  open_: open_,
  closed: closed,
  parked: parked,
  resolved: resolved,
  fromJson: fromJson
};

function fetchAgentWiseSummary(param) {
  return Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/tickets/agent_wise_summary", (function (param) {
                return Json_decode.field("agent_wise_summary", (function (param) {
                              return Json_decode.list(fromJson, param);
                            }), param);
              }));
}

var initialState = {
  loading: true,
  filter: false,
  data: /* [] */0
};

function AgentWiseSummary(props) {
  var match = React.useState(function (param) {
        return initialState;
      });
  var setState = match[1];
  var state = match[0];
  React.useEffect((function (param) {
          Js_promise.then_((function (agentDataList) {
                  return Promise.resolve(Curry._1(setState, (function (state) {
                                    return {
                                            loading: false,
                                            filter: state.filter,
                                            data: agentDataList
                                          };
                                  })));
                }), fetchAgentWiseSummary());
        }), []);
  var onApplyFilter = function (param) {
    Curry._1(setState, (function (state) {
            return {
                    loading: true,
                    filter: false,
                    data: state.data
                  };
          }));
    Js_promise.then_((function (agentDataList) {
            return Promise.resolve(Curry._1(setState, (function (state) {
                              return {
                                      loading: false,
                                      filter: state.filter,
                                      data: agentDataList
                                    };
                            })));
          }), fetchAgentWiseSummary());
  };
  if (state.loading === true) {
    return JsxRuntime.jsx("p", {
                children: "Loading"
              });
  } else {
    return JsxRuntime.jsxs(JsxRuntime.Fragment, {
                children: [
                  state.filter ? JsxRuntime.jsx(Filters$ReactHooksTemplate.make, {
                          onClose: (function (param) {
                              Curry._1(setState, (function (state) {
                                      return {
                                              loading: state.loading,
                                              filter: false,
                                              data: state.data
                                            };
                                    }));
                            }),
                          onApply: onApplyFilter,
                          showDateFilter: false,
                          showFilterPills: false
                        }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                  JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx("h2", {
                                        children: "Agent Summary",
                                        className: "text-xl font-semibold"
                                      }),
                                  JsxRuntime.jsxs("button", {
                                        children: [
                                          JsxRuntime.jsx("img", {
                                                className: "h-14-px mr-2-px",
                                                src: Image$ReactHooksTemplate.filterButton
                                              }),
                                          "Filters"
                                        ],
                                        className: "bg-ghostwhite border border-gray-400\n            shadow-inner flex rounded py-2 px-3 text-xs",
                                        id: "filters",
                                        onClick: (function (param) {
                                            Curry._1(setState, (function (state) {
                                                    return {
                                                            loading: state.loading,
                                                            filter: true,
                                                            data: state.data
                                                          };
                                                  }));
                                          })
                                      })
                                ],
                                className: "flex justify-between items-center mb-30-px border-b border-gray-300 px-30-px py-16-px"
                              }),
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsxs("table", {
                                      children: [
                                        JsxRuntime.jsx("thead", {
                                              children: JsxRuntime.jsxs("tr", {
                                                    children: [
                                                      JsxRuntime.jsx("th", {
                                                            children: JsxRuntime.jsxs("div", {
                                                                  children: [
                                                                    "Email",
                                                                    JsxRuntime.jsx("img", {
                                                                          className: "ml-4-px",
                                                                          src: Image$ReactHooksTemplate.heading
                                                                        })
                                                                  ],
                                                                  className: "flex"
                                                                }),
                                                            className: "px-4 py-2"
                                                          }),
                                                      JsxRuntime.jsx("th", {
                                                            children: JsxRuntime.jsxs("div", {
                                                                  children: [
                                                                    "Touch Point",
                                                                    JsxRuntime.jsx("img", {
                                                                          className: "ml-4-px",
                                                                          src: Image$ReactHooksTemplate.heading
                                                                        })
                                                                  ],
                                                                  className: "flex"
                                                                }),
                                                            className: "px-4 py-2"
                                                          }),
                                                      JsxRuntime.jsx("th", {
                                                            children: JsxRuntime.jsxs("div", {
                                                                  children: [
                                                                    "Lob",
                                                                    JsxRuntime.jsx("img", {
                                                                          className: "ml-4-px",
                                                                          src: Image$ReactHooksTemplate.heading
                                                                        })
                                                                  ],
                                                                  className: "flex"
                                                                }),
                                                            className: "px-4 py-2"
                                                          }),
                                                      JsxRuntime.jsx("th", {
                                                            children: JsxRuntime.jsxs("div", {
                                                                  children: [
                                                                    "Open",
                                                                    JsxRuntime.jsx("img", {
                                                                          className: "ml-4-px",
                                                                          src: Image$ReactHooksTemplate.heading
                                                                        })
                                                                  ],
                                                                  className: "flex"
                                                                }),
                                                            className: "px-4 py-2"
                                                          }),
                                                      JsxRuntime.jsx("th", {
                                                            children: JsxRuntime.jsxs("div", {
                                                                  children: [
                                                                    "Parked",
                                                                    JsxRuntime.jsx("img", {
                                                                          className: "ml-4-px",
                                                                          src: Image$ReactHooksTemplate.heading
                                                                        })
                                                                  ],
                                                                  className: "flex"
                                                                }),
                                                            className: "px-4 py-2"
                                                          }),
                                                      JsxRuntime.jsx("th", {
                                                            children: JsxRuntime.jsxs("div", {
                                                                  children: [
                                                                    "Closed",
                                                                    JsxRuntime.jsx("img", {
                                                                          className: "ml-4-px",
                                                                          src: Image$ReactHooksTemplate.heading
                                                                        })
                                                                  ],
                                                                  className: "flex"
                                                                }),
                                                            className: "px-4 py-2"
                                                          }),
                                                      JsxRuntime.jsx("th", {
                                                            children: JsxRuntime.jsxs("div", {
                                                                  children: [
                                                                    "Resolved",
                                                                    JsxRuntime.jsx("img", {
                                                                          className: "ml-4-px",
                                                                          src: Image$ReactHooksTemplate.heading
                                                                        })
                                                                  ],
                                                                  className: "flex"
                                                                }),
                                                            className: "px-4 py-2"
                                                          }),
                                                      JsxRuntime.jsx("th", {
                                                            children: JsxRuntime.jsxs("div", {
                                                                  children: [
                                                                    "Total",
                                                                    JsxRuntime.jsx("img", {
                                                                          className: "ml-4-px",
                                                                          src: Image$ReactHooksTemplate.heading
                                                                        })
                                                                  ],
                                                                  className: "flex"
                                                                }),
                                                            className: "px-4 py-2"
                                                          })
                                                    ]
                                                  }),
                                              className: "font-medium p-4 bg-ghostwhite text-aurometalsaurus"
                                            }),
                                        JsxRuntime.jsx("tbody", {
                                              children: $$Array.of_list(List.map((function (x) {
                                                          return JsxRuntime.jsxs("tr", {
                                                                      children: [
                                                                        JsxRuntime.jsx("td", {
                                                                              children: x.email,
                                                                              className: "px-4 py-2"
                                                                            }),
                                                                        JsxRuntime.jsx("td", {
                                                                              children: Belt_Option.getWithDefault(x.touchPoint, ""),
                                                                              className: "px-4 py-2"
                                                                            }),
                                                                        JsxRuntime.jsx("td", {
                                                                              children: Belt_Option.getWithDefault(x.lob, ""),
                                                                              className: "px-4 py-2"
                                                                            }),
                                                                        JsxRuntime.jsx("td", {
                                                                              children: String(x.open_),
                                                                              className: "px-4 py-2"
                                                                            }),
                                                                        JsxRuntime.jsx("td", {
                                                                              children: String(x.parked),
                                                                              className: "px-4 py-2"
                                                                            }),
                                                                        JsxRuntime.jsx("td", {
                                                                              children: String(x.closed),
                                                                              className: "px-4 py-2"
                                                                            }),
                                                                        JsxRuntime.jsx("td", {
                                                                              children: String(x.resolved),
                                                                              className: "px-4 py-2"
                                                                            }),
                                                                        JsxRuntime.jsx("td", {
                                                                              children: String(((x.resolved + x.open_ | 0) + x.parked | 0) + x.closed | 0),
                                                                              className: "px-4 py-2"
                                                                            })
                                                                      ],
                                                                      className: "border-b border-bottom-gray-600"
                                                                    }, x.email);
                                                        }), state.data))
                                            })
                                      ],
                                      className: "text-left table-auto w-full border-separate text-xs font-medium"
                                    }),
                                className: "flex items-center px-30-px"
                              })
                        ]
                      })
                ]
              });
  }
}

var make = AgentWiseSummary;

exports.AgentData = AgentData;
exports.fetchAgentWiseSummary = fetchAgentWiseSummary;
exports.initialState = initialState;
exports.make = make;
/* react Not a pure module */
